export default {
	$app: $('#kaspersky-inc'),
	$window: $(window),
	$document: $(document),
	$html: $(document.documentElement),
};
